<template>
	<div id="SeoDashboard">
		<dashboardMenu @updateCategories="[]" />

		<div class="container">
			<div class='pt-5 row '>
						<div class="w-100 text-center">
							<h3 class="mb-0 ml-3">SEO</h3>
							<span class='description'>SEO é a otimização do seu site para melhorar o posicionamento no Google e outros buscadores.</span>
						</div>
				<div class="col-12">
					<div class="row align-items-center">

						<div class="col-12 mb-4">
							<label for="userArtisticName" >Título do Site</label>
							<span class='description'>
								Nome comercial que aparece no título do navegador, após o nome da página acessada.
							</span>
							<input
								type="text"
								id="userArtisticName"
								class="form-control"
								maxlength="80"
								v-model="userData.userArtisticName"
							/>
						</div>

						<div class="col-12 mb-4">
							<label for="siteLanguage" >Idioma do site</label>
							<span class='description'>
								Selecione o idoma do site.
							</span>
							<select
								type="text"
								id="userlang"
								class="form-control"
								v-model="userData.siteLanguage"
							>
								<option value="pt-br">Português</option>
								<option value="en">Inglês</option>
								<option value="es">Espanhol</option>
								<option value="it">Italiano</option>
							</select>
						</div>

						<div class="col-12 mb-4">
							<label for="userSegment">Segmento</label>
							<span class='description'>
								Descreva a sua área de atuação. Isso ajuda muito quando visitantes procurarem na internet por esse termo. Por exemplo, caso alguém procure por "Fotógrafos em Rio Preto" e o seu segmento estiver também como "Fotógrafo", as chances do seu site aparecer nessa busca são maiores.
							</span>
							<input
								type="text"
								id="userSegment"
								class="form-control"
								v-model="userData.activeSegment"
								@keyup="matchQuery"
								@blur="checkQuery"
								@focus="choseOne = false"
								maxlength="40"
								placeholder="Digite para pesquisar"
							/>
						</div>

						<div class="w-100 py-2 mb-3" v-if="!choseOne">
							<p class="mb-1" v-for="item in listFilter" :key="item.id">
								<span class="item--segment" @click="handleSegment(item, true)">
									{{
									item.description
									}}
								</span>
							</p>
						</div>
						<div class="w-100 py2 mb-3" v-else>
							<UserSubsegmentManager
								:subsegments="getSubsegments"
								:selectedSubsegments="getSelectedSubsegments"
								@updateSelectedSubsegments="handleSubsegments($event)"
							></UserSubsegmentManager>
						</div>

						<div class="col-12 mb-4">
							<!-- Css inline, passar pra arquivo assim que possível -->
							<label for="siteDescription">Descrição do site</label>
							<span class='description'>
								Breve descrição com umas duas linhas que vai aparecer embaixo do nome do seu site nos resultados do Google e outros buscadores.
							</span>
							<textarea
								rows="5"
								id="siteDescription"
								class="form-control"
								style="overflow-y: hidden!important;"
								maxlength="400"
								v-model="userData.siteDescription"
							></textarea>
						</div>

						<div class="col-12 mb-4" >
							<label for="seoText"
								>Texto do H1</label
							>
							<span class='description'>
								Texto em destaque na página inicial do seu site que resume sua área de atuação. Recomendamos que preencha com sua atividade principal e cidades onde atua (de 1 a 3) e em seguida o nome do site, ex: Fotógrafo de casamentos, Uberaba, Uberlândia - MG, Nome do fotógrafo.
							</span>
							<input
								id="seoText"
								type="text"
								maxlength="250"
								v-model="userData.h1"
								class="form-control"
							/>
						</div>

						<div class="col-12">
							<label for>Tags SEO</label>
							<span class='description'>
								Áreas que atua, cidades, serviços ou produtos.Ex: fotos de casamento, ensaios, pré-wedding, 15 anos, Uberaba, Uberlândia, MG, Minas Gerais.
							</span>
							<div style="padding-top: 10px;" class="mb-3">
								<span class="add-item-seo mr-3" @click="addTagModal = !addTagModal">
									<i class="fas fa-plus"></i>
								</span>
								<span class="item-seo" v-for="(tag, index) in userData.userTags" :key="index">
									{{ tag.name }}
									<i class="fal fa-times ml-2" @click="removeTag(index, tag.id)"></i>
								</span>
							</div>
						</div>

						<div class="col-12 mb-4">
							<label class='w-100'>Dicas</label>
							<span class='description'>
								Pense como o seu cliente irá procurar o seu trabalho para definir as palavras-chaves adequadas. Utilize o Google Trends para saber termos mais pesquisados:
								<a href="https://trends.google.com/">www.google.com/trends</a>
							</span>
						</div>

						<div class="col-12">
							<label for>Exibir informações</label>
							<CheckBox
								label="Barra informativa - Cookies"
								:visible="userData.cookiebar"
								@onCheck="userData.cookiebar = $event"/>

                        </div>
					</div>
				</div>




				<div class='position-fixed ps-b-4 ps-h-center to-front'>
					<button class="d-flex align-items-center btn btn-primario create_post px-4 px-lg-5 py-3" @click="saveData()">
						Salvar alterações
						<i v-if="loading" class="fal fa-spinner fa-spin fa-2x ml-2"></i>
					</button>
				</div>

                <div class="col-12 mb-4" style="padding-bottom: 100px;">
                    <label for="document">
                        CNPJ
                    </label>

                    <input
                        id="document"
                        type="text"
                        v-model="userData.document"
                        class="form-control"
                    />
                </div>

				<b-modal
					hide-footer
					@shown="focusMyElement"
					ref="addTagModal"
					v-model="addTagModal"
					modal-class="full-white"
					centered
					title="Adicionar Tag"
					ok-title="Adicionar"
					cancel-title="Cancelar"
					@ok="addTag()"
				>
					<div class="row">
						<div class="col-12">
							<b-form-input
								ref="focusThis"
								id="newTag"
								v-model="newTag"
								class="default_input"
								type="text"
								placeholder="Digite a nova TAG"
								maxlength="50"
							></b-form-input>
						</div>
						<div class="col-12 text-center mt-4">
							<button @click="addTag()" class="btn btn-primario">Adicionar</button>
						</div>
					</div>
				</b-modal>

			</div>
		</div>

	</div>
</template>
<script>
import dashboardMenu from "@/components/DashboardMenu";
import axios from "axios";
import UserSubsegmentManager from "@/components/molecules/UserSubsegmentManager";
import sectionsMixins from "@/mixins/sectionsMixins";
import CheckBox from "@/components/atoms/checkBox.vue"

export default {
	name: "PerfilComponent",
	data() {
		return {
			userData: {
				userEmail: null,
				activeSegment: null,
				activeSubsegments: [],
				userArtisticName: null,
				siteLanguage: null,
				siteDescription: null,
				h1: null,
                document: '',
				userTags: [],
				location: {
					lat: null,
					lng: null,
				},
				cookiebar: false,
			},
			listFilter: [],
			choseOne: true,
			errormessage: "",
			addTagModal: false,
			newTag: null,
			editableElement:{},
			categories:[],
			loading: false
		};
	},
	mixins: [
		sectionsMixins,
	],
	components: {
		UserSubsegmentManager,
		dashboardMenu,
		CheckBox
	},
	beforeCreate() {
		this.$store.dispatch("GET_SEGMENTS");
	},
	created() {
		this.getData();
		this.populateCategories()
	},
	mounted() {
		this.segments = this.$store.state.wizard.segments;
	},
	methods: {
		handleSubsegments(item) {
			let findSubsegment = this.$store.state.siteActive.segment.subSegments.findIndex(
				(selected) => selected.description == item.description
			);
			if (findSubsegment < 0) {
				this.$store.dispatch("ADD_SUBSEGMENT_PAINEL", [item]);
			} else {
				this.$store.dispatch("REMOVE_SUBSEGMENT_PAINEL", [
					findSubsegment,
				]);
			}
		},
		checkSelected(item) {
			let selectedSubsegments = this.$store.state.siteActive.segment
				.subSegments;
			let findSubsegment = this.$store.state.siteActive.segment.subSegments.findIndex(
				(selected) => selected.description == item.description
			);
			if (findSubsegment < 0) {
				return false;
			} else {
				return true;
			}
		},
		matchQuery() {
			if (this.userData.activeSegment.length >= 2) {
				this.listFilter = this.listSegments();
			} else {
				this.listFilter = [];
			}
		},
		listSegments() {
			let captalizeQuery =
				this.userData.activeSegment.charAt(0).toUpperCase() +
				this.userData.activeSegment.slice(1);
			if (this.userData.activeSegment.length > 0) {
				return this.$store.state.wizard.segments
					.filter(
						(segment) =>
							segment.search.filter(
								(item) =>
									item.description.indexOf(captalizeQuery) !==
									-1
							).length
					)
					.map((segment) => ({
						description: segment.description,
					}));
			} else {
				return this.$store.state.wizard.segments;
			}
		},
		checkQuery() {
			this.$store.dispatch("PAINEL_UPDATE_SEGMENT", [
				this.userData.activeSegment,
			]);
			let itemSelected = this.$store.state.wizard.segments.find(
				(segment) => segment.description == this.userData.activeSegment
			);
			if (!itemSelected) {
				this.$store.dispatch("CLEAR_SELECTEDS_SUBSEGMENTS");
				this.$store.dispatch("CLEAR_SUBSEGMENTS");
			}
			setTimeout(() => {
				this.choseOne = true;
			}, 600);
		},
		handleSegment(item, clear) {
			//Função de selecionar o segmento ao digitar no campo de pesquisa
			let itemSelected = this.$store.state.wizard.segments.find(
				(segment) => segment.description == item.description
			);
			if (itemSelected) {
				this.$store.dispatch("WIZARD_UPDATE_SUBSEGMENTS", [
					itemSelected.subsegments,
				]);
			}
			if (clear) {
				this.$store.dispatch("CLEAR_SELECTEDS_SUBSEGMENTS");
			}
			this.userData.activeSegment = item.description;
			this.$store.dispatch("PAINEL_UPDATE_SEGMENT", [item.description]);
		},
		getData() {
			let totalData = "";
			let token = this.$session.get("jwt");
			axios({
				method: "get",
				url: `${process.env.ROOT_API}/api/site/${this.siteId}`,
				data: totalData,
				headers: {
					Authorization: "Bearer " + token,
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}).then((response) => {
				this.userData.userArtisticName = response.data.siteName;
				this.userData.siteLanguage = response.data.siteLanguage;
				this.userData.userEmail = response.data.contactEmail;
				this.userData.mainEmail = response.data.mainEmail;
				this.userData.siteDescription = response.data.siteDescription;
				this.userData.userTags = response.data.tags;
				this.userData.whatsappMessage = response.data.whatsappMessage;
				this.userData.h1 = response.data.h1;
				this.userData.cookiebar = response.data.cookiebar;
                this.userData.document = response.data.document;


				if (response.data.location) {
					this.userData.location = response.data.location;
				}
				this.userData.activeSegment = response.data.segment.segment;
				let active = {
					description: this.userData.activeSegment,
				};
				if (this.userData.activeSegment) {
					setTimeout(() => {
						this.handleSegment(active, false);
					}, 1500);
				}
				this.matchQuery();
			});
		},
		addTag() {
			var newTagData = { name: this.newTag, siteId: this.siteId };
			let token = this.$session.get("jwt");
			axios({
				method: "post",
				url: `${process.env.ROOT_API}/api/site/${this.siteId}/tag/create`,
				data: newTagData,
				headers: {
					Authorization: "Bearer " + token,
					// 'Content-Type': 'application/x-www-form-urlencoded'
				},
			})
				.then((response) => {
					//handle success
					this.userData.userTags.push({
						name: response.data.name,
						id: response.data.id,
					});
					this.newTag = null;
				})
				.catch(function (response) {
					//handle error
					console.log("Erro ao adicionar Tag");
				});
			this.$refs.addTagModal.hide();
		},
		removeTag(index, tagId) {
			let token = this.$session.get("jwt");
			axios({
				method: "post",
				url: `${process.env.ROOT_API}/api/site/${this.siteId}/tag/${tagId}/delete`,
				data: null,
				headers: {
					Authorization: "Bearer " + token,
					// 'Content-Type': 'application/x-www-form-urlencoded'
				},
			})
				.then((response) => {
					this.userData.userTags.splice(index, 1);
				})
				.catch(function (response) {
					//handle error
					console.log("Erro ao remover tag");
				});
		},
        validateCNPJError() {
            this.$bvToast.toast(`Verifique os dados inseridos e tente novamente.`, {
                title: `Insira um número de documento válido`,
                solid: true,
                variant: 'danger',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 3000,
            })
        },
        validateCNPJ(value) {
            if (!value) return true

            // Aceita receber o valor como string, número ou array com todos os dígitos
            const isString = typeof value === 'string'
            const validTypes = isString || Number.isInteger(value) || Array.isArray(value)

            // Elimina valor em formato inválido
            if (!validTypes) {
                this.validateCNPJError()
                return false;
            }

            // Filtro inicial para entradas do tipo string
            if (isString) {
                // Limita ao máximo de 18 caracteres, para CNPJ formatado
                if (value.length > 18) {
                    this.validateCNPJError();
                    return false;
                }

                // Teste Regex para veificar se é uma string apenas dígitos válida
                const digitsOnly = /^\d{14}$/.test(value)
                // Teste Regex para verificar se é uma string formatada válida
                const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value)

                // Se o formato é válido, usa um truque para seguir o fluxo da validação
                if (digitsOnly || validFormat) true
                // Se não, retorna inválido
                else {
                    this.validateCNPJError();
                    return false;
                }
            }

            // Guarda um array com todos os dígitos do valor
            const match = value.toString().match(/\d/g)
            const numbers = Array.isArray(match) ? match.map(Number) : []

            // Valida a quantidade de dígitos
            if (numbers.length !== 14) {
                this.validateCNPJError();
                return false;
            }

            // Elimina inválidos com todos os dígitos iguais
            const items = [...new Set(numbers)]
            if (items.length === 1) {
                this.validateCNPJError();
                return false;
            }

            // Cálculo validador
            const calc = (x) => {
                const slice = numbers.slice(0, x)
                let factor = x - 7
                let sum = 0

                for (let i = x; i >= 1; i--) {
                const n = slice[x - i]
                sum += n * factor--
                if (factor < 2) factor = 9
                }

                const result = 11 - (sum % 11)

                return result > 9 ? 0 : result
            }

            // Separa os 2 últimos dígitos de verificadores
            const digits = numbers.slice(12)

            // Valida 1o. dígito verificador
            const digit0 = calc(12)
            if (digit0 !== digits[0]) {
                this.validateCNPJError();
                return false;
            }

            // Valida 2o. dígito verificador
            const digit1 = calc(13)
            if (digit1 === digits[1]) {
                return true;
            } else {
                this.validateCNPJError();
                return false;
            }
        },
		focusMyElement,
		saveData() {
			this.loading = true
			this.errormessage = "";
			this.userData.activeSubsegments = this.$store.state.siteActive.segment.subSegments;
			var updadeProfile = this.userData;
			let token = this.$session.get("jwt");

            //validação de CNPJ comentada e ignorada pois foi solicitado que seja possivel inserir qualquer coisa no campo de documento.
            //const validateDocument = this.validateCNPJ(this.userData.document);
            const validateDocument = true;

           if (!validateDocument) {
               this.loading = false
               return;
           }

			axios({
				method: "post",
				url: `${process.env.ROOT_API}/api/site/${this.siteId}/update`,
				data: updadeProfile,
				headers: {
					Authorization: "Bearer " + token,
					// 'Content-Type': 'application/x-www-form-urlencoded'
				},
			})
			.then((response) => {
				if (response.data.status == 1) {
					this.$emit("updateMenuOption");
				} else {
					this.errormessage = response.data.error;
					this.$emit("resetSaveData");
				}
				this.loading = false
			})
			.catch((response) => {
				//handle error
				this.errormessage = response.data.error;
				this.loading = false
			});
		},
	},
	// props: {
	// 	saveData: { type: Boolean },
	// },
	watch: {
		categories: {
			handler: function () {
				if (this.categories.length > 0) {
					this.editableElement = this.categories.filter(
						(category) => category.isHome == true
					);
				}
			},deep :true
		},
	},
	computed: {
		getSubsegments() {
			return this.$store.state.wizard.subsegments;
		},
		getSelectedSubsegments() {
			return this.$store.state.siteActive.segment.subSegments;
		},
	},
};

function focusMyElement(e) {
	this.$refs.focusThis.focus();
}
</script>

<style scoped>
label{
	font-weight: 600;
}
.ap-input:hover ~ .ap-input-icon,
.ap-input:focus ~ .ap-input-icon,
.ap-input-icon:hover {
	display: none !important;
}
.ap-input,
.ap-hint {
	border: none;
	border-bottom: 1px solid #dddddd;
	border-radius: 0;
}
.error_message {
	color: #d61a1a;
}
#newTag {
	background-color: #ffff !important;
}
.item-seo {
	border-radius: 25px;
	padding: 3px 12px;
	margin: 5px 3px 5px 0;
	display: inline-block;
	font-size: 14px;
	border: 1px solid #dddddd;
}
.item-seo i:hover,
.add-item-seo:hover,
.item--segment {
	cursor: pointer;
}
.item--segment:hover {
	font-weight: 700;
}
label {
	width: 100%;
	color: #2a2a2a;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: .75px;
    line-height: 12px;
    margin-top: 33px;
    text-transform: uppercase;
}
.description{
	text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #6e6e6e;
    display: block;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    margin-bottom: 4px;
    margin-top: 2px;
}
input, textarea{
	margin-top: 1rem;
    color: rgb(14, 14, 14);
    font-size: 16px;
    line-height: 22px;
}
.container .row.align-items-center{
	margin-bottom: 1.5rem;
}
.fa-2x {
    font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/SeoDashboard.vue